import React from 'react';
import PropTypes from 'prop-types';
import Input from 'components/base/inputs/base-input/Input';

const NumberInput = (props) => {
  return <Input className="input--number" type="number" {...props} />;
};

NumberInput.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  fieldRef: PropTypes.shape({}),
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  valueTransform: PropTypes.func,
};

export default NumberInput;
